<template>
  <div class="bim-calendar__wrapper">
    <div v-if="$slots.before" class="mb-9">
      <slot name="before" />
    </div>
    <DateCalendar
      class="bim-calendar"
      :events="events"
      :language="language"
      :wide="wide"
      :lang="lang"
    />
    <div v-if="$slots.after" class="mt-9">
      <slot name="after" />
    </div>
  </div>
</template>

<script>
import DateCalendar from '@/components/core/bimCalendar/index.js'

import en from '@/components/core/bimCalendar/locale/en'
import ru from '@/components/core/bimCalendar/locale/ru'

const langEnum = {
  ru,
  en,
}

export default {
  name: 'bimCalendar',
  components: {
    DateCalendar
  },
  props: {
    language: {
      type: String,
      default: 'ru'
    },
    /**
     * Показывать список при true
     */
    wide: {
      type: Boolean,
      default: false
    },
    exampleData: [Array, null],
    /**
     * Префикс для апи (api.bim.bimlib.ru)
     */
    webApiHost: {
      type: String,
      default: '/web-api'
    }
  },
  data () {
    return {
      events: [],
      lang: {}
    }
  },
  watch: {
    language (val) {
      this.changeLocale(val)
    }
  },
  async mounted () {
    this.changeLocale(this.language)

    let events

    if (this.exampleData) {
      events = this.exampleData
    } else {
      events = await fetch(`${this.webApiHost}/events`)
        .then(r => r.json())
        .then(r => r.data)
        .catch(console.error)
    }

    this.events = events
      .map(e => {
        e.date_start = new Date(e.date_start)
        e.date_end = new Date(e.date_end)
        return e
      })
      .sort((a, b) => {
        return b.date_end.getTime() - a.date_start.getTime()
      })
  },
  methods: {
    changeLocale (lang) {
      this.lang = langEnum[lang]
    }
  }
}
</script>

<style lang="scss" scoped>
.bim-calendar__wrapper {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e8e8e8;
  padding: 24px;
}

.bim-calendar ::v-deep {
  @media screen and (max-width: $breakpoint-md) {
    .mx-datepicker-body {
      flex-flow: column;
      align-items: center;
    }
    .list {
      margin-left: 0 !important;
      margin-top: 24px;
      padding: 0 14px;
    }
  }

  @media screen and (max-width: $breakpoint-sm) {
    .mx-datepicker-main .mx-datepicker-content {
      padding: 6px;

      .mx-datepicker-body {
        overflow: hidden;
      }
    }
    .mx-table.mx-table-date .cell div{
      width: 24px;
      height: 24px;
      font-size: 10px;
    }
  }
}
</style>
